import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { guruttoAiPageMeta, guruttoAiSchema } from 'components/common/schema'
import Template from 'components/cases/gurutto-ai'

const GuruttoAi: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...guruttoAiPageMeta} />
      <JsonLd data={guruttoAiSchema} />
      <Template />
    </>
  )
}

export default GuruttoAi
